import { createAction } from '@reduxjs/toolkit';

import { SET_NOTIFICATION, type Notification } from './types';

export const setNotification = createAction<Notification | null, typeof SET_NOTIFICATION>(SET_NOTIFICATION);
